<template>
  <v-container
    fluid
  >
    <v-row dense no-gutters v-if="$store.state.brand != 'cldy'">
      <v-app-bar
        app
        dense
      >
        <a v-if="$store.state.brand === 'qoxy'" href="https://manage.qoxy.com">
          <img src="/qoxylogo.png">
        </a>
        <v-spacer></v-spacer>
        <a
          class="header-btn"
          :class="{ 'header-btn-disabled': guestIdentityLocked }"
          :aria-disabled="guestIdentityLocked ? 'true' : 'false'"
          @click="gotoLogin()"
        >LOGIN</a>
        <span>|</span>
        <a
          class="header-btn"
          :class="{ 'header-btn-disabled': guestIdentityLocked }"
          :aria-disabled="guestIdentityLocked ? 'true' : 'false'"
          @click="gotoLogin()"
        >REGISTER</a>
        <v-badge
          color="green"
          :content="$store.state.shoppingCart.total_count + ''"
          overlap
          offset-x="20"
          offset-y="20"
        >
          <v-btn
            icon
            large
            :disabled="guestIdentityLocked"
            @click="goToCart()"
          >
            <v-avatar
              size="32px"
              item
            >
              <v-icon>mdi-cart-outline</v-icon>
            </v-avatar>
          </v-btn>
        </v-badge>
      </v-app-bar>
    </v-row>
    <CldyHeader
      v-if="$store.state.brand == 'cldy'"
      :navigation-locked="guestIdentityLocked"
    ></CldyHeader>
    <v-row class="no-margin-horizontal">
      <v-col cols="1">
      </v-col>
      <v-col cols="10">
        <component
          v-bind:is="component"
          :show-payment-block="false"
          :external-loading="checkoutLoading || cartReloading || loginProcessing ||
          airwallexCartRecoveryLoading || airwallexCartCompletionInProgress ||
          hasAirwallexCartPayment"
          @mutation-busy="cartMutationBusy = $event"
        ></component>
      </v-col>
    </v-row>
    <v-row no-gutters v-if="shoppingCart.total_amount > 0">
      <v-col cols="1">
      </v-col>
      <v-col cols="10">
        <v-row>
          <v-col cols="12">
            <h3>Please enter your email address to continue checkout</h3>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="8" lg="4">
            <v-text-field
              v-model="email"
              dense
              outlined
              clearable
              label="Email"
              :disabled="guestIdentityLocked"
            ></v-text-field>
            <v-progress-circular
              indeterminate
              color="primary"
              v-if="lookupProgressing"
            ></v-progress-circular>
          </v-col>
          <v-col cols="2" class="btn-group">
            <v-btn
              dense
              small
              color="primary"
              :loading="lookupProgressing"
              :disabled="guestIdentityLocked"
              @click="search()"
            >Continue</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="showLogin" dense>
          <v-col cols="8" lg="4">
            <v-text-field type="password" label="Password" v-model="password"
              dense
              outlined
              hint="Please enter password to checkout as returning customer"
              persistent-hint
              :disabled="guestIdentityLocked"
            ></v-text-field>
          </v-col>
          <v-col cols="4" class="btn-group">
            <v-btn
              v-if="!otp"
              dense small
              color="primary"
              :loading="loginProcessing"
              :disabled="guestIdentityLocked"
              @click="loginOtp()"
            >Login</v-btn>
            <v-btn
              dense small
              color="error"
              :disabled="guestIdentityLocked"
              @click="forgetPassword()"
            >Forget Password</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="showLogin && otp" dense>
          <v-col cols="12">
            <h5>For your security, we've sent a one-time password to your email
              address at {{ email }}</h5>
          </v-col>
          <v-col cols="8" lg="4">
            <v-text-field
              id="otp"
              label="OTP"
              name="OTP"
              dense
              outlined
              v-model="emailOtp"
              :error="error.emailOtp"
              :error-messages="errorMessage.emailOtp"
              :disabled="guestIdentityLocked"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-btn
              dense small
              color="primary"
              :loading="loginProcessing"
              :disabled="guestIdentityLocked"
              @click="verifyOtp()"
            >Verify Otp</v-btn>
            <v-btn
              dense small
              color="primary"
              :disabled="guestIdentityLocked"
              @click="resendOtp()"
            >Resend OTP</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="showSignUp">
          <v-col cols="12">
            <h3 class="red--text">
              Please fill up the information below and click on the Checkout button to
              complete your purchase
            </h3>
          </v-col>
          <v-col cols="12">
            <v-form
              ref="profileForm"
              v-model="profileValid"
            >
              <profile ref="profile" :default-email="email"></profile>
            </v-form>
          </v-col>
        </v-row>
        <v-row v-if="showSignUp">
          <v-col cols="12">
            <v-card
            outlined
          >
            <v-card-text>
              <v-row no-gutters dense>
                <v-row v-if="paymentMethod == 3" no-gutters dense>
                  <v-col cols="12" lg="6">
                    <stripe-payment
                      :amount="shoppingCart.total_amount"
                      :card.sync="creditCard"
                      :invalid.sync="creditCardInvalid"
                    ></stripe-payment>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox
                      v-if="$store.state.brand === 'cldy'"
                      label="Save as default card? I authorise CLDY.com PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                    ></v-checkbox>
                    <v-checkbox
                      v-else
                      label="Save as default card? I authorise GOCLOUDEASY PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row v-if="paymentMethod == 4" no-gutters dense>
                  <v-col cols="12" lg="6">
                    <paypal-payment
                      :orderid="paypalOrderId"
                      :amount="shoppingCart.total_amount"
                      :saveasdefaultcard="saveAsDefaultCard"
                      @interface="getChildInterface"
                      :card.sync="creditCard"
                      :invalid.sync="creditCardInvalid"
                    ></paypal-payment>
                  </v-col>
                  <!--
                  <v-col cols="12">
                    <v-checkbox
                      label="Save as default card? I authorise GOCLOUDEASY PTE. LTD. to send
                    instructions to the financial institution that issued my card to take payments
                    from my card account in accordance with the terms of my agreement with you."
                      v-model="saveAsDefaultCard"
                    ></v-checkbox>
                  </v-col>
                  -->
                </v-row>
                <v-row v-if="[7, 8].includes(paymentMethod)" no-gutters dense>
                  <v-col cols="12" lg="6">
                    <airwallex-payment
                      :allow-apple-pay="applePayEnabled"
                      :apple-pay="airwallexWalletSelected"
                      :key="paymentMethod"
                      show-method-selector
                      @apple-pay-selected="selectAirwallexApplePay"
                      :amount="shoppingCart.total_amount"
                      :invalid.sync="creditCardInvalid"
                      :disabled="checkoutLoading || hasAirwallexCartPayment"
                      @interface="getAirwallexInterface"
                    ></airwallex-payment>
                  </v-col>
                </v-row>
              </v-row>
            </v-card-text>
          </v-card>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn
              v-if="paymentMethod == 4"
              color="primary"
                   :loading="checkoutLoading"
                   :disabled="checkoutLoading || loginProcessing || cartReloading ||
                   cartMutationBusy || creditCardInvalid ||
                   shoppingCart.total_amount < 0.01"
                   @click="checkout">
                  {{ airwallexWalletSelected
                    ? 'Continue with Apple Pay' : 'Checkout (Visa/Master)' }}
                </v-btn>
            <v-btn
              v-else
              color="primary"
              :loading="checkoutLoading"
              :disabled="checkoutLoading || loginProcessing || cartReloading ||
              cartMutationBusy || airwallexCartRecoveryLoading ||
              airwallexCartCompletionInProgress ||
              (creditCardInvalid && !hasAirwallexCartPayment) ||
              (!hasAirwallexCartPayment && shoppingCart.total_amount < 0.01)"
              @click="checkout">
              {{ hasAirwallexCartPayment
                ? 'Continue in shopping cart'
                : 'Checkout' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-footer v-if="$store.state.brand != 'cldy'"
      dark
      padless
      :app="true"
      :fixed="true"
    >
      <v-card
        flat
        tile
        class="indigo lighten-1 white--text text-center"
        width="100%"
      >
        <v-card-text class="white--text">
          {{ new Date().getFullYear() }} — <strong>Powered By GoCloudEasy Pte Ltd</strong>
        </v-card-text>
      </v-card>
    </v-footer>
    <CldyFooter v-if="$store.state.brand == 'cldy'"></CldyFooter>
    <v-dialog
      v-model="resetPasswordDialog"
      width="1024"
    >
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <h3 class="text-center">Generate a one time code to login.
            An email with one-time login password will be sent to your registered email.</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            text
            @click="resetPasswordDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="resetPasswordLoading"
            :disabled="resetPasswordLoading"
            @click="generateOneTimePassword()"
          >
            Generate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { getApiBaseUrl } from '@/config/api';
import { mapState } from 'vuex';
import airwallexWallet from '../../mixins/airwallex-wallet';
import ShoppingCart from './ShoppingCart.vue';
import Profile from '../components/Profile.vue';
import {
  StripePayment, StripeSavedCards, PaypalPayment, PaypalSavedCards, AirwallexPayment,
} from '../components/payment_modules';
import {
  isAirwallexPaymentPending,
} from '../../plugins/airwallex-payment';
import { getGuestShoppingCartId } from '../../plugins/guest-shopping-cart';
import { flushPendingTosAcceptances } from '../../plugins/tos-audit';
import airwallexCartRecovery from '../../mixins/airwallex-cart-recovery';
import CldyHeader from './CldyHeader.vue';
import CldyFooter from './CldyFooter.vue';

export default {
  name: 'Guest',
  mixins: [airwallexWallet, airwallexCartRecovery],
  components: {
    Profile,
    ShoppingCart,
    StripePayment,
    StripeSavedCards,
    PaypalPayment,
    PaypalSavedCards,
    AirwallexPayment,
    CldyHeader,
    CldyFooter,
  },
  data() {
    return {
      otp: false,
      emailOtp: '',
      paymentMethod: '',
      paypalOrderId: '',
      resetPasswordDialog: false,
      resetPasswordLoading: false,
      loggedIn: true,
      shoppingCartId: null,
      component: ShoppingCart,
      email: null,
      password: null,
      lookupProgressing: false,
      loginProcessing: false,
      checkoutLoading: false,
      cartMutationBusy: false,
      cartReloading: false,
      showLogin: false,
      showSignUp: false,
      saveAsDefaultCard: true,
      creditCardInvalid: true,
      creditCard: null,
      signUpToken: false,
      signUpUser: null,
      tosAccepted: false,
      tosAuditSucceeded: true,
      error: {
        emailOtp: false,
      },
      errorMessage: {
        emailOtp: '',
      },
      rules: {
        required: (value) => !!value || 'This field is required.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        },
      },
      profileValid: true,
    };
  },
  created() {
    this.airwallexCartRecoveryLoading = false;

    this.$api.get('partner/payment-methods')
      .then((response) => {
        this.paymentMethods = this.filterWalletPaymentMethods(response.data);
      })
      .catch(() => { this.paymentMethods = []; });

    this.$api.get('partner/default-payment-method').then((response) => {
      this.$set(this, 'paymentMethod', response.data);
      if (this.paymentMethod === 4) {
        this.creditCardInvalid = false;
      }
    });

    if (this.$store.state.user.role) {
      this.loggedIn = false;
    }

    this.shoppingCartId = getGuestShoppingCartId(
      this.$store.state.shoppingCartId,
    );

    if (this.shoppingCartId) {
      this.reloadShoppingCart();
    }
  },
  methods: {
    flushPendingTos(user) {
      return flushPendingTosAcceptances({
        api: this.$api,
        store: this.$store,
        authToken: user.auth_token,
      });
    },
    async openAuthenticatedCart(user) {
      await this.flushPendingTos(user);
      await this.$store.dispatch('setCurrentUser', user);
      await this.$store.dispatch('showDashboard');
      localStorage.setItem('app', JSON.stringify(this.$store.state));
      try {
        await this.$router.push({
          name: 'Retail.ShoppingCart',
          params: { brand: this.$store.state.brand },
        });
      } catch (error) {
        if (!error || error.name !== 'NavigationDuplicated') {
          throw error;
        }
      }
    },
    getChildInterface(childInterface) {
      this.$options.childInterface = childInterface;
    },
    getAirwallexInterface(childInterface) {
      this.$options.airwallexInterface = childInterface;
    },
    airwallexCartRecoveryEndpoint() {
      return 'customer/shopping-cart';
    },
    getAirwallexCartAuthToken() {
      const user = this.signUpUser || this.$store.state.user || {};
      const authToken = this.signUpToken || user.auth_token;

      return authToken ? window.btoa(authToken) : null;
    },
    fetchAirwallexCartRecovery() {
      const authToken = this.getAirwallexCartAuthToken();

      if (!authToken) {
        return Promise.reject(
          new Error('An authenticated account is required to recover this payment.'),
        );
      }

      return this.$api.get(this.airwallexCartRecoveryEndpoint(), {
        params: {
          auth_token: authToken,
        },
        headers: {
          Authorization: `Basic ${authToken}`,
        },
      });
    },
    syncAirwallexCartData(cart) {
      this.$store.dispatch('syncShoppingCart', cart);
    },
    acknowledgeAirwallexCartRecovery(recovery) {
      const authToken = this.getAirwallexCartAuthToken();

      if (!recovery || !recovery.attempt_id || !authToken) {
        return Promise.resolve();
      }

      return this.$api.post('customer/payment/cart-recovery/acknowledge', {
        attempt_id: recovery.attempt_id,
        auth_token: authToken,
      }, this.airwallexCartRecoveryAcknowledgeConfig({
        headers: {
          Authorization: `Basic ${authToken}`,
        },
      }));
    },
    async onAirwallexCartRecoveryCompleted(invoice) {
      this.$store.dispatch('resetShoppingCart');
      this.$store.dispatch('addAlert', {
        id: Date.now(),
        type: 'success',
        message: 'Your payment is submitted successfully.',
      });
      this.$store.dispatch('showDashboard');
      localStorage.setItem('app', JSON.stringify(this.$store.state));
      await this.$router.push({
        name: 'Retail.TaxInvoiceList',
        params: { brand: this.$store.state.brand },
      }).catch(() => {});
      window.location.href = `${getApiBaseUrl()}/v1/tax-invoice/${invoice.invoice_no}/view?view_token=${invoice.view_token}&system_currency=${window.systemCurrency}`;
    },
    handoffAirwallexCartRecovery() {
      if (!this.signUpUser) {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'error',
          message: 'Please sign in to open your authenticated shopping cart and continue this payment safely.',
        });
        return Promise.resolve(false);
      }

      return this.openAuthenticatedCart(this.signUpUser)
        .then(() => true)
        .catch(() => {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: 'We could not open your authenticated shopping cart. Please try again or open it from your account.',
          });
          return false;
        });
    },
    async handleGuestAirwallexCartError(error) {
      const completed = await this.handleAirwallexCartError(error);

      if (!completed && this.hasAirwallexCartPayment) {
        await this.handoffAirwallexCartRecovery();
      }

      return completed;
    },
    reloadShoppingCart() {
      this.cartReloading = true;
      return this.$api.get(`partner/shopping-cart?shopping_cart_id=${this.shoppingCartId}`)
        .then((data) => {
          this.$store.dispatch('syncShoppingCart', data.data);
        })
        .finally(() => {
          this.cartReloading = false;
        });
    },
    search() {
      if (this.guestIdentityLocked) {
        return;
      }

      if (this.email !== '') {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          if (this.rules.email(this.email) !== true) {
            return;
          }
          this.lookupProgressing = true;
          this.$api.post('guest/lookup-email', {
            email: this.email,
          })
            .then((response) => {
              if (response.data.exist) {
                this.showLogin = true;
                this.showSignUp = false;
              } else {
                this.showLogin = false;
                this.showSignUp = true;
              }
            })
            .finally(() => {
              this.lookupProgressing = false;
            });
        }, 500);
      } else {
        this.showLogin = false;
        this.showSignUp = false;
      }
    },
    gotoLogin() {
      if (this.guestIdentityLocked) {
        return;
      }

      const { brand } = this.$store.state;
      this.$router.push({ name: 'Retail.Login', params: { brand } })
        .catch(() => {
        });
    },
    goToCart() {
      if (this.guestIdentityLocked) {
        return;
      }

      const { brand } = this.$store.state;
      if (this.$store.state.user.role) {
        this.$router.push({
          name: 'Retail.ShoppingCart',
          params: { brand },
        })
          .catch(() => {
          });
      } else {
        this.$router.push({
          name: 'Retail.GuestShoppingCart',
          params: { brand },
        })
          .catch(() => {
          });
      }
    },
    gotoHome() {
      if (this.guestIdentityLocked) {
        return;
      }

      const { brand } = this.$store.state;
      this.$router.push({ name: 'Retail.Guest', params: { brand } })
        .catch(() => {
        });
    },
    login() {
      if (this.guestIdentityLocked) {
        return;
      }

      this.loginProcessing = true;
      this.$api.post('login', {
        email: this.email,
        password: this.password,
        shopping_cart_id: this.shoppingCartId,
      })
        .then(async (response) => {
          if (response.data.user) {
            await this.openAuthenticatedCart(response.data.user);
          } else {
            this.loginProcessing = false;
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: 'Invalid login.',
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: error.response.data.message,
            });
          } else {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: error.message,
            });
          }
          this.loginProcessing = false;
        });
    },
    loginOtp() {
      if (this.guestIdentityLocked) {
        return;
      }

      this.loginProcessing = true;
      this.$api.post('login-otp', {
        email: this.email,
        password: this.password,
        shopping_cart_id: this.shoppingCartId,
      })
        .then(async (response) => {
          if (response.data.success) {
            this.loginProcessing = false;
            this.otp = true;
          } else if (response.data.user) {
            await this.openAuthenticatedCart(response.data.user);
          } else {
            this.loginProcessing = false;
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: 'Invalid login.',
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: error.response.data.message,
            });
          } else {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: error.message,
            });
          }
          this.loginProcessing = false;
        });
    },
    verifyOtp() {
      if (this.guestIdentityLocked) {
        return;
      }

      this.loginProcessing = true;
      this.$api.post('login-otp', {
        email: this.email,
        password: this.password,
        shopping_cart_id: this.shoppingCartId,
        otp: this.emailOtp,
      })
        .then(async (response) => {
          if (response.data.user) {
            await this.openAuthenticatedCart(response.data.user);
          } else {
            this.loginProcessing = false;
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: 'Invalid login.',
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: error.response.data.message,
            });
          } else {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: error.message,
            });
          }
          this.loginProcessing = false;
        });
    },
    resendOtp() {
      if (this.guestIdentityLocked) {
        return;
      }

      this.$api.post('resend-otp', {
        email: this.email,
        password: this.password,
      }).then((response) => {
        if (response.data.success) {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'success',
            message: `New OTP has been sent to your email address ${this.email}`,
          });
        }
      });
    },
    forgetPassword() {
      if (this.guestIdentityLocked) {
        return;
      }

      this.resetPasswordDialog = true;
    },
    checkout() {
      if (this.checkoutLoading
        || this.loginProcessing
        || this.cartReloading
        || this.cartMutationBusy
        || this.airwallexCartRecoveryLoading
        || this.airwallexCartCompletionInProgress
      ) {
        return;
      }

      this.checkoutLoading = true;

      if (this.hasAirwallexCartPayment && this.signUpUser) {
        this.handoffAirwallexCartRecovery()
          .finally(() => {
            this.checkoutLoading = false;
          });
        return;
      }

      const customerProfile = this.$refs.profile.getProfileData();
      customerProfile.email = this.email;
      customerProfile.shopping_cart_id = this.shoppingCartId;

      if (!this.signUpToken) {
        if (!this.$refs.profileForm.validate()) {
          this.checkoutLoading = false;
          return;
        }
        this.$api.post('sign-up', customerProfile)
          .then(async (response) => {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'Your account is created. We are now processing the payment.',
            });

            if (response.data.user) {
              this.signUpUser = response.data.user;
              this.signUpToken = response.data.user.auth_token;
              await this.flushPendingTos(this.signUpUser);
              await this.$store.dispatch('setCurrentUser', this.signUpUser);
              localStorage.setItem('app', JSON.stringify(this.$store.state));
              this.capturePayment(this.signUpToken);
            } else {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: 'System error. Please contact support.',
              });
              this.checkoutLoading = false;
            }
          })
          .catch((error) => {
            if (error.response) {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.response.data.message || error.response.data,
              });
            } else {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.message,
              });
            }
            this.checkoutLoading = false;
          });
      } else {
        this.flushPendingTos(this.signUpUser)
          .then(() => {
            this.$store.dispatch('setCurrentUser', this.signUpUser);
            localStorage.setItem('app', JSON.stringify(this.$store.state));
            this.capturePayment(this.signUpToken);
          })
          .catch(() => {
            this.checkoutLoading = false;
          });
      }
    },
    capturePayment(token) {
      if (this.paymentMethod === 3) {
        this.$api.post('customer/payment',
          {
            payment_type_id: this.paymentMethod,
            amount: this.shoppingCart.total_amount,
            save_as_default_card: this.saveAsDefaultCard,
            auth_token: window.btoa(token),
          })
          .then((paymentResponse) => {
            const stripePaymentObj = {
              payment_method: {
                card: this.creditCard,
              },
            };

            if (this.saveAsDefaultCard) {
              stripePaymentObj.setup_future_usage = 'off_session';
            }

            window.stripeClient.confirmCardPayment(paymentResponse.data.client_secret,
              stripePaymentObj)
              .then(async (result) => {
                if (result.error) {
                  await this.$store.dispatch('addAlert', {
                    id: Date.now(),
                    type: 'error',
                    message: result.error,
                  });
                }

                if (result.paymentIntent.status === 'requires_capture') {
                  await this.$api.post('customer/payment', {
                    payment_type_id: this.paymentMethod,
                    confirm: 1,
                    id: result.paymentIntent.id,
                    auth_token: window.btoa(token),
                  })
                    .then((subresponse) => {
                      const successMessage = 'Your payment is submitted successfully.';
                      this.$store.dispatch('resetShoppingCart');
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'success',
                        message: successMessage,
                      });
                      this.$store.dispatch('showDashboard');
                      localStorage.setItem('app', JSON.stringify(this.$store.state));
                      this.$router.push({
                        name: 'Retail.TaxInvoiceList',
                        params: { brand: this.$store.state.brand },
                      })
                        .catch(() => {
                        });
                      window.location.href = `${getApiBaseUrl()}/v1/tax-invoice/${subresponse.data.invoice_no}/view?view_token=${subresponse.data.view_token}&system_currency=${window.systemCurrency}`;
                    });
                }
              });
          })
          .catch((error) => {
            if (error.response) {
              const errorMsg = error.response.data.message || error.response.data;

              if (typeof errorMsg === 'string'
                && errorMsg.indexOf('remove it from the cart') !== -1
              ) {
                this.$store.dispatch('showDashboard');
                localStorage.setItem('app', JSON.stringify(this.$store.state));
                this.$router.push({
                  name: 'Retail.ShoppingCart',
                  params: { brand: this.$store.state.brand },
                })
                  .catch(() => {
                  });
              }

              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: errorMsg,
              });
            } else {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.message,
              });
            }
          })
          .finally(() => {
            this.checkoutLoading = false;
          });
      }

      if (this.paymentMethod === 4) {
        this.$api.post('customer/payment',
          {
            payment_type_id: this.paymentMethod,
            amount: this.shoppingCart.total_amount,
            save_as_default_card: this.saveAsDefaultCard,
            auth_token: window.btoa(token),
          })
          .then((response) => {
            this.$set(this, 'paypalOrderId', response.data.order_id);
            this.$nextTick(() => {
              this.$options.childInterface.checkout()
                .then((payload) => {
                  if (payload.liabilityShift !== 'NO'
                    && payload.authenticationStatus
                    && payload.authenticationStatus !== 'YES') {
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: '3D Secure Authentication fails. Please retry again.',
                    });
                    this.loading = false;
                    return;
                  }

                  if (payload.liabilityShift === 'NO'
                    && payload.liabilityShifted === false
                    && payload.authenticationStatus
                    && payload.authenticationStatus === 'NO') {
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: 'You have exited 3D Secure Authentication. Please retry again.',
                    });
                    this.loading = false;
                    return;
                  }

                  this.$api.post('customer/payment', {
                    id: this.paypalOrderId,
                    payment_type_id: this.paymentMethod,
                    amount: this.shoppingCart.total_amount,
                    save_as_default_card: this.saveAsDefaultCard,
                    confirm: 1,
                    auth_token: window.btoa(token),
                  })
                    .then((subresponse) => {
                      const successMessage = 'Your payment is submitted successfully.';
                      this.$store.dispatch('resetShoppingCart');
                      this.$store.dispatch('addAlert', {
                        id: Date.now(),
                        type: 'success',
                        message: successMessage,
                      });
                      this.$store.dispatch('showDashboard');
                      localStorage.setItem('app', JSON.stringify(this.$store.state));
                      this.$router.push({
                        name: 'Retail.TaxInvoice',
                        params: {
                          brand: this.$store.state.brand,
                          id: subresponse.data.invoice_id,
                          first: true,
                        },
                      });
                    });
                })
                .catch((error) => {
                  if (error.message.indexOf('semantically incorrect') > 0
                    || error.message.indexOf('not well-formed') > 0
                  ) {
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: 'We are sorry, the transaction failed. Please check the card information or try with another card.',
                    });
                  } else {
                    this.$store.dispatch('addAlert', {
                      id: Date.now(),
                      type: 'error',
                      message: `An error occurred ${error.message}. Please retry again.`,
                    });
                  }
                  this.loading = false;
                })
                .finally(() => {
                  this.loading = false;
                });
            });
          })
          .catch((error) => {
            if (error.response) {
              const errorMsg = error.response.data.message || error.response.data;

              if (typeof errorMsg === 'string'
                && errorMsg.indexOf('remove it from the cart') !== -1
              ) {
                this.$store.dispatch('showDashboard');
                localStorage.setItem('app', JSON.stringify(this.$store.state));
                this.$router.push({
                  name: 'Retail.ShoppingCart',
                  params: { brand: this.$store.state.brand },
                })
                  .catch(() => {
                  });
              }

              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: errorMsg,
              });
            } else {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'error',
                message: error.message,
              });
            }
          })
          .finally(() => {
            this.checkoutLoading = false;
          });
      }

      if ([7, 8].includes(this.paymentMethod)) {
        const confirmPayment = (paymentIntentId) => this.$api.post(
          'customer/payment',
          {
            payment_type_id: Number(this.paymentMethod),
            confirm: 1,
            id: paymentIntentId,
            auth_token: window.btoa(token),
          },
        ).then((response) => {
          this.applyAirwallexCartRecoveryFromResponse(response);
          return response;
        });
        const finishPayment = async (response) => {
          if (!response) {
            return;
          }

          const responseRecovery = this.applyAirwallexCartRecoveryFromResponse(response);

          if (responseRecovery && responseRecovery.action === 'completed') {
            await this.completeAirwallexCartRecovery(responseRecovery);
            return;
          }

          if (responseRecovery && responseRecovery.action === 'blocked') {
            throw new Error(
              'The active credit card payment requires reconciliation. Please contact support.',
            );
          }

          if (isAirwallexPaymentPending(response)) {
            const paymentIntentId = this
              .resolveAirwallexCartPaymentIntentId(response);

            if (!paymentIntentId) {
              throw new Error('The credit card processor did not return the pending payment details.');
            }

            if (!this.hasAirwallexCartRecoveryPayload(response)) {
              this.rememberAirwallexCartRecovery({
                action: 'check_status',
                recoverable: true,
                payment_intent_id: paymentIntentId,
                mode: 'new',
              });
            }
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'info',
              message: 'Your card authorization is still processing. Opening your authenticated shopping cart to continue safely.',
            });
            await this.handoffAirwallexCartRecovery();
            return;
          }

          if (response.data && response.data.invoice_id) {
            await this.completeAirwallexCartInvoice(response.data);
            return;
          }

          if (responseRecovery && ['check_status', 'finalize'].includes(
            responseRecovery.action,
          )) {
            await this.handoffAirwallexCartRecovery();
            return;
          }

          throw new Error('The credit card checkout could not be completed.');
        };
        const handlePaymentError = (error) => this.handleGuestAirwallexCartError(error);
        const completePayment = (paymentPromise) => paymentPromise
          .then(finishPayment)
          .catch(handlePaymentError)
          .finally(() => {
            this.checkoutLoading = false;
          });
        this.rememberAirwallexCartRecovery({
          action: 'authorize',
          recoverable: true,
          payment_intent_id: null,
          mode: 'new',
          payment_card_id: null,
          amount: Number(this.shoppingCart.total_amount).toFixed(2),
        });
        const authorizePayment = () => this.$api.post('customer/payment', {
          payment_type_id: Number(this.paymentMethod),
          amount: this.shoppingCart.total_amount,
          auth_token: window.btoa(token),
        })
          .then((response) => {
            const responseRecovery = this.applyAirwallexCartRecoveryFromResponse(response);

            if (responseRecovery && responseRecovery.action === 'completed') {
              return response;
            }

            if (responseRecovery && responseRecovery.action === 'blocked') {
              return response;
            }

            const paymentIntentId = this
              .resolveAirwallexCartPaymentIntentId(response);

            if (!paymentIntentId) {
              throw new Error('The credit card processor did not return payment details.');
            }

            if (responseRecovery
              && ['check_status', 'finalize'].includes(responseRecovery.action)
            ) {
              return this.pollAirwallexCartPayment(
                () => confirmPayment(paymentIntentId),
                isAirwallexPaymentPending(response) ? response : null,
              );
            }

            if (isAirwallexPaymentPending(response)) {
              if (!this.hasAirwallexCartRecoveryPayload(response)) {
                this.rememberAirwallexCartRecovery({
                  action: 'check_status',
                  recoverable: true,
                  payment_intent_id: paymentIntentId,
                  mode: 'new',
                });
              }
              return this.pollAirwallexCartPayment(
                () => confirmPayment(paymentIntentId),
                response,
              );
            }

            this.rememberAirwallexCartRecovery({
              action: 'authorize',
              recoverable: true,
              payment_intent_id: paymentIntentId,
              mode: 'new',
            });

            if (this.creditCardInvalid) {
              this.$store.dispatch('addAlert', {
                id: Date.now(),
                type: 'info',
                message: 'This payment needs card confirmation. Opening your authenticated shopping cart to continue safely.',
              });
              return this.handoffAirwallexCartRecovery().then(() => null);
            }

            if (!response.data.client_secret || !this.$options.airwallexInterface) {
              throw new Error('The credit card payment form is not ready.');
            }

            return this.$options.airwallexInterface.confirmIntent(
              paymentIntentId,
              response.data.client_secret,
            ).then(() => {
              this.rememberAirwallexCartRecovery({
                action: 'check_status',
                recoverable: true,
                payment_intent_id: paymentIntentId,
                mode: 'new',
              });
              return this.pollAirwallexCartPayment(
                () => confirmPayment(paymentIntentId),
              );
            });
          });

        completePayment(authorizePayment());
      }
    },
    generateOneTimePassword() {
      this.resetPasswordLoading = true;
      this.$api.post('onetime-password', {
        email: this.email,
        shopping_cart_id: this.shoppingCartId,
      })
        .then(() => {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'success',
            message: 'Please check your email for one-time password!',
          });
          this.resetPasswordDialog = false;
        })
        .finally(() => {
          this.resetPasswordLoading = false;
        });
    },
  },
  watch: {
  },
  computed: {
    guestIdentityLocked() {
      return this.checkoutLoading
        || this.loginProcessing
        || this.lookupProgressing
        || this.cartReloading
        || this.cartMutationBusy
        || this.airwallexCartRecoveryLoading
        || this.airwallexCartCompletionInProgress
        || this.hasAirwallexCartPayment;
    },
    ...mapState({
      shoppingCart: 'shoppingCart',
    }),
  },
};
</script>

<style scoped>
  .header-btn {
    margin-right: 5px;
    margin-left: 5px;
  }

  .header-btn-disabled {
    opacity: .5;
    pointer-events: none;
  }

  .v-btn:not(:last-child) {
    margin-right: 10px;
  }

  .no-margin-horizontal {
    margin-left: 0;
    margin-right: 0;
  }
</style>
